import React from 'react';
import PropTypes from 'prop-types';

import {Link, Stack, Typography} from 'views/components';
import {SentimentDissatisfiedOutlined} from 'views/icons';
import {Translate} from 'views/module';


const ErrorBox = (props) => {
  const {setChallengeName} = props;
  return (
    <Stack
      alignItems="center"
      spacing={{xs: 2, sm: 4}}
    >
      <SentimentDissatisfiedOutlined
        sx={{
          height: {
            xs: 36, sm: 52,
          },
          width: {
            xs: 36, sm: 52,
          },
          color: 'text.contrast',
        }}
      />
      <Stack spacing={1} alignItems="center">
        <Typography variant="h4" fontWeight="normal" align="center" color="text.primary">
          <Translate expression='auth.MagicLink.LoginFailed' />
        </Typography>
        <Link
          variant="body1"
          onClick={() => setChallengeName('START')}
        >
          <Translate expression='auth.MagicLink.LoginFailedLink' />
        </Link>
      </Stack>
    </Stack>
  );
};

ErrorBox.propTypes = {
  setChallengeName: PropTypes.func.isRequired,
};

export default ErrorBox;
